function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { trackEvent } from "services/bigbrain-service";
import { TAB_CLICKED } from "constants/bigbrain-event-types";
import MondayDemoTabsAsset from "../monday-demo-tab-asset/monday-demo-tabs-asset";
import MondayDemoTimeline from "../monday-demo-timeline/monday-demo-timeline";
import { StyledMondayDemoTabsDesktopComponent } from "./monday-demo-tabs-desktop-component.scss";
export const DEMO_FINISHED_SELECTED_TAB_INDEX = -1;
const MondayDemoTabsDesktopComponent = (props)=>{
    const { tabs } = props, rest = _object_without_properties(props, [
        "tabs"
    ]);
    const tabsWithVideoPlayerRefs = [];
    tabs.forEach((tab)=>{
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            asset: _object_spread_props(_object_spread({}, tab.asset), {
                video: _object_spread_props(_object_spread({}, tab.asset.video), {
                    videoPlayerRef: useRef(null)
                })
            })
        }));
    });
    return /*#__PURE__*/ _jsx(MondayDemoTabsComponentInner, _object_spread({
        tabs: tabsWithVideoPlayerRefs
    }, rest));
};
const MondayDemoTabsComponentInner = (props)=>{
    var _tabs_;
    const { fullParagraph, tabs, buttonConfig, theme } = props;
    const [selectedTab, setSelectedTab] = useState(0);
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const [videoDurations, setVideoDurations] = useState([]);
    const [buttonHighlighted, setButtonHighlighted] = useState(false);
    const VISIBILITY_SENSOR_OFFSET = 100;
    const onTabClick = ({ index })=>{
        setSelectedTab(index);
        setButtonHighlighted(false);
        trackEvent(TAB_CLICKED, {
            kind: tabs === null || tabs === void 0 ? void 0 : tabs[index].tabLabel,
            info1: index
        });
    };
    const onVideoEnded = (index)=>{
        if (index < tabs.length - 1) {
            setSelectedTab(index + 1);
        }
        // last tab
        if (index === tabs.length - 1) {
            setSelectedTab(DEMO_FINISHED_SELECTED_TAB_INDEX); // demo finished
            setButtonHighlighted(true);
        }
    };
    const setVideoDuration = (index, duration)=>{
        if (videoDurations[index] !== duration) {
            const newVideoDurations = [
                ...videoDurations
            ];
            newVideoDurations[index] = duration;
            setVideoDurations(newVideoDurations);
        }
    };
    const getCurrentAsset = (index)=>{
        var _tabs_index;
        if (index === DEMO_FINISHED_SELECTED_TAB_INDEX) {
            var _tabs_;
            return tabs === null || tabs === void 0 ? void 0 : (_tabs_ = tabs[tabs.length - 1]) === null || _tabs_ === void 0 ? void 0 : _tabs_.asset;
        }
        return tabs === null || tabs === void 0 ? void 0 : (_tabs_index = tabs[index]) === null || _tabs_index === void 0 ? void 0 : _tabs_index.asset;
    };
    const onVisibilityChange = (isVisible)=>{
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    useEffect(()=>{
        var _tabs_selectedTab_asset_video_videoPlayerRef_current, _tabs_selectedTab_asset_video_videoPlayerRef, _tabs_selectedTab_asset_video, _tabs_selectedTab_asset, _tabs_selectedTab;
        tabs === null || tabs === void 0 ? void 0 : (_tabs_selectedTab = tabs[selectedTab]) === null || _tabs_selectedTab === void 0 ? void 0 : (_tabs_selectedTab_asset = _tabs_selectedTab.asset) === null || _tabs_selectedTab_asset === void 0 ? void 0 : (_tabs_selectedTab_asset_video = _tabs_selectedTab_asset.video) === null || _tabs_selectedTab_asset_video === void 0 ? void 0 : (_tabs_selectedTab_asset_video_videoPlayerRef = _tabs_selectedTab_asset_video.videoPlayerRef) === null || _tabs_selectedTab_asset_video_videoPlayerRef === void 0 ? void 0 : (_tabs_selectedTab_asset_video_videoPlayerRef_current = _tabs_selectedTab_asset_video_videoPlayerRef.current) === null || _tabs_selectedTab_asset_video_videoPlayerRef_current === void 0 ? void 0 : _tabs_selectedTab_asset_video_videoPlayerRef_current.seekTo(0);
    }, [
        selectedTab
    ]);
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ _jsxs(StyledMondayDemoTabsDesktopComponent, {
            className: "monday-demo-tabs-desktop-component",
            children: [
                /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph)),
                /*#__PURE__*/ _jsxs("div", {
                    className: "monday-demo-tabs-asset-and-timeline",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "monday-demo-tabs-assets-wrapper",
                            children: [
                                tabs.map((tab, index)=>// get videoDurations by order, render everything only when component is visible
                                    wasComponentEverVisible && index <= videoDurations.length ? /*#__PURE__*/ _jsx(MondayDemoTabsAsset, {
                                        selectedTab: selectedTab,
                                        index: index,
                                        isCurrent: selectedTab === index,
                                        asset: getCurrentAsset(index),
                                        onVideoEnded: ()=>onVideoEnded(index),
                                        // play only the current video excluding final button step's video (so triggers when video is done won't be fired)
                                        autoPlay: selectedTab === index && index !== DEMO_FINISHED_SELECTED_TAB_INDEX,
                                        setVideoDuration: (duration)=>setVideoDuration(index, duration)
                                    }, index) : null),
                                wasComponentEverVisible && /*#__PURE__*/ _jsx(MondayDemoTabsAsset, {
                                    selectedTab: selectedTab,
                                    index: DEMO_FINISHED_SELECTED_TAB_INDEX,
                                    isCurrent: selectedTab === DEMO_FINISHED_SELECTED_TAB_INDEX,
                                    // show last video first frame
                                    asset: tabs === null || tabs === void 0 ? void 0 : (_tabs_ = tabs[tabs.length - 1]) === null || _tabs_ === void 0 ? void 0 : _tabs_.asset,
                                    // play the last video so it would stay on the last frame
                                    autoPlay: true,
                                    onVideoEnded: onVideoEnded
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(MondayDemoTimeline, {
                            theme: theme,
                            tabs: tabs,
                            selectedTab: selectedTab,
                            buttonConfig: buttonConfig,
                            buttonHighlighted: buttonHighlighted,
                            wasComponentEverVisible: wasComponentEverVisible,
                            onTabClick: onTabClick,
                            videoDuration: videoDurations[selectedTab]
                        })
                    ]
                })
            ]
        })
    });
};
export default MondayDemoTabsDesktopComponent;
